import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { ChangesItemMenuBtn, ChangesItemMenuContent } from './components'
import { useUserItemMenu } from './useUserItemMenu'

interface Props {
  buttonCn: string
  onRestore: () => void
}

export const ChangesItemMenu: React.FC<Props> = ({ buttonCn, onRestore }) => {
  const { onClick } = useUserItemMenu(onRestore)

  return (
    <DropdownMenu.Root
      align="end"
      content={ChangesItemMenuContent}
      onClick={onClick}
    >
      <ChangesItemMenuBtn className={buttonCn} />
    </DropdownMenu.Root>
  )
}
